import LegendSlider from './slider.component';
export default LegendSlider;
